<script>
import { formatTimestamp } from '../utils/formatTimestamp'
import { normalizeCapitalization, underscoresToSpaces } from '../utils/normalizeEventData'
import moment from 'moment'
import NoData from '../common-components/table/NoData'

export default {
  name: 'MobilizeV2EventsTable',
  props: {
    value: { type: Array, required: false, default: () => [] },
    search: { type: String, required: false, default: '' },
    adCount: { type: Object, required: false, default: () => ({}) }
  },
  components: {
    NoData
  },
  computed: {
    headers() {
      return [
        { value: 'ad_created', text: 'Ad', filterable: false }, // is disabled, will need to be set by us
        { value: 'id', text: 'ID', sortable: false, filterable: false },
        { value: 'data.browser_url', text: 'Website', sortable: false, filterable: false },
        { value: 'data.featured_image_url', text: 'Image', sortable: false, filterable: false },
        { value: 'data.title', text: 'Title', width: 200 },
        { value: 'data.preview', text: 'Preview', sortable: false, filterable: false },
        { value: 'data.event_type', text: 'Event Type', filterable: false },
        { value: 'data.is_virtual', text: 'Virtual', filterable: false },
        { value: 'data.sponsor.name', text: 'Sponsor' },
        { value: 'data.location.locality', text: 'City', filterable: false },
        { value: 'data.location.region', text: 'State', filterable: false },
        // { value: 'data.map', text: 'Map', sortable: false }, // not implemented: lat + long
        // takes first timeslot
        { value: 'data.timeslots[0].start_date', text: 'Start Date', width: 125, filterable: false },
        { value: 'data.startTime', text: 'Start Time', width: 125, filterable: false },
        { value: 'data.timeslots[0].end_date', text: 'End Date', width: 125, filterable: false },
        { value: 'data.endTime', text: 'End Time', width: 125, filterable: false }
      ]
    }
  },
  inheritAttrs: false,
  methods: {
    formatTimestamp,
    normalizeCapitalization,
    underscoresToSpaces,
    moment,
    start(item) {
      const { timeslots } = item.data
      const firstTimeslot = timeslots && timeslots[0]
      const start = firstTimeslot && firstTimeslot.start_date
      return start && start * 1000
    },
    end(item) {
      const { timeslots } = item.data
      const lastTimeslot = timeslots && timeslots[timeslots.length - 1]
      const end = lastTimeslot && lastTimeslot.end_date
      return end && end * 1000
    }
  }
}
</script>

<template>
  <v-data-table
    item-key="id"
    class="elevation-1 events-table"
    loading-text="Loading..."
    :headers="headers"
    :value="value"
    :search="search"
    @input="$emit('input', $event)"
    v-bind="$attrs"
  >
    <template v-slot:[`item.ad_created`]="{ item }">
      <v-simple-checkbox v-model="((adCount || {})[item.id] || {}).hasAds" disabled></v-simple-checkbox>
    </template>
    <template v-slot:[`item.id`]="{ item }">
      <router-link :to="'/mobilizev2/events/' + item.id">
        {{ item.data.id }}
      </router-link>
    </template>
    <template v-slot:[`item.data.browser_url`]="{ item }">
      <a :href="item.data.browser_url" target="_blank">
        <v-icon color="#1976d1">link</v-icon>
      </a>
    </template>
    <template v-slot:[`item.data.featured_image_url`]="{ item }">
      <img :src="item.data.featured_image_url" />
    </template>
    <template v-slot:[`item.data.title`]="{ item }">
      {{ item.data.title }}
    </template>
    <template v-slot:[`item.data.preview`]="{ item }">
      <router-link :to="'/mobilizev2/events/' + item.data.id">
        <v-icon color="#1976d1">remove_red_eye</v-icon>
      </router-link>
    </template>
    <template v-slot:[`item.data.event_type`]="{ item }">
      <span>{{ underscoresToSpaces(normalizeCapitalization(item.data.event_type, true)) }}</span>
    </template>
    <template v-slot:[`item.data.is_virtual`]="{ item }">
      <span>{{ item.data.is_virtual ? 'Yes' : 'No' }}</span>
    </template>
    <!-- <template v-slot:[`item.data.map`]="">
      <v-icon color="#1976d1">map</v-icon>
    </template> -->
    <template v-slot:[`item.data.timeslots[0].start_date`]="{ item }">
      <span>{{ formatTimestamp(start(item), 'date') }}</span>
    </template>
    <template v-slot:[`item.data.timeslots[0].end_date`]="{ item }">
      <span>{{ formatTimestamp(end(item), 'date') }}</span>
    </template>
    <template v-slot:[`item.data.startTime`]="{ item }">
      <span>{{ formatTimestamp(start(item), 'time') }}</span>
    </template>
    <template v-slot:[`item.data.endTime`]="{ item }">
      <span>{{ formatTimestamp(end(item), 'time') }}</span>
    </template>
    <template v-slot:no-data>
      <no-data dataType="event" image="girl-clock.png" />
    </template>
  </v-data-table>
</template>

<style lang="scss">
.events-table table > tbody > tr > td:nth-child(1),
.events-table table > thead > tr > th:nth-child(1),
.events-table table > tbody > tr > td:nth-child(2),
.events-table table > thead > tr > th:nth-child(2),
.events-table table > tbody > tr > td:nth-child(3),
.events-table table > thead > tr > th:nth-child(3) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 99;
  background: white;
}

// the event table in the events view
.events-table table > tbody > tr > td:nth-child(2),
.events-table table > thead > tr > th:nth-child(2) {
  left: 66px;
}

.events-table table > tbody > tr > td:nth-child(3),
.events-table table > thead > tr > th:nth-child(3) {
  left: 150px;
}

.events-table table > thead > tr > th:nth-child(1),
.events-table table > thead > tr > th:nth-child(2),
.events-table table > thead > tr > th:nth-child(3) {
  z-index: 99;
}

// the event table inside the ad campaign creation flow form
form {
  .events-table table > tbody > tr > td:nth-child(2),
  .events-table table > thead > tr > th:nth-child(2) {
    left: 57px;
  }

  .events-table table > tbody > tr > td:nth-child(3),
  .events-table table > thead > tr > th:nth-child(3) {
    left: 122px;
  }

  .events-table table > thead > tr > th:nth-child(1),
  .events-table table > thead > tr > th:nth-child(2),
  .events-table table > thead > tr > th:nth-child(3) {
    z-index: 99;
  }
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #eee;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover,
.v-data-table__selected {
  td.text-start {
    background: #eee !important;
  }
}
</style>
